import type { NoNullProperties } from "@bbj-types/utils";

export const cleanObject = <T extends object>(obj: T): Partial<NoNullProperties<T>> => {
  const copy: Partial<NoNullProperties<T>> = {};
  for (const key in obj) {
    const value = obj[key];
    if (
      value !== undefined &&
      value !== null &&
      value !== "" &&
      (!Array.isArray(value) || value.length > 0) &&
      (typeof value !== "object" || Object.keys(value).length > 0 || value.constructor !== Object)
    ) {
      Object.assign(copy, { [key]: value });
    }
  }
  return copy;
};
